import { CardTypesEnum } from "@common-fe/common-fe";

export enum ReactivationSteps {
  FORM = 'FORM',
  RESUME = 'RESUME',
}

export interface ReactivationPlan {
  id: string;
  name: string;
  type: CardTypesEnum;
  validFrom?: string;
  validTo?: string;
  isPlanLevelFunding?: boolean;
}

export interface ReactivationPlanToSubmit {
  plan_id: number;
  external_bank_account_id?: number;
}

export interface ReactivationPlanSelected extends ReactivationPlanToSubmit {
  isPlanLevelFunding?: boolean;
}
